import {
  Autocomplete,
  FormControl,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

const TextFieldStyled = styled(TextField)(() => {
  return {
    fieldset: {
      borderWidth: "1px",
    },
    [`& > .MuiAutocomplete-inputRoot`]: {
      padding: 0,
    },
  };
});

export function APISelector({
  defaultApi,
  urls,
  label,
  onUpdate,
}: {
  defaultApi: string;
  urls: string[];
  label: string;
  onUpdate: (val: string) => void;
}) {
  const onChange = (api: string | null) => {
    onUpdate(api ?? "");
  };

  if (!urls.length) {
    return <></>;
  }

  return (
    <Stack sx={{ width: "100%", gap: 1 }}>
      <Typography>{label}</Typography>
      <FormControl fullWidth size={"small"}>
        <Autocomplete
          fullWidth
          autoSelect
          size={"small"}
          freeSolo
          options={urls}
          defaultValue={defaultApi}
          onChange={(_, value) => {
            onChange(value);
          }}
          renderInput={(params) => <TextFieldStyled {...params} />}
        />
      </FormControl>
    </Stack>
  );
}
